import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconAvatarTrash: React.FC<IconProps> = ({ width = 24, height = 24 }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3 6.38597C3 5.90152 3.34538 5.50879 3.77143 5.50879L6.43567 5.50832C6.96502 5.49306 7.43202 5.11033 7.61214 4.54412C7.61688 4.52923 7.62232 4.51087 7.64185 4.44424L7.75665 4.05256C7.8269 3.81241 7.8881 3.60318 7.97375 3.41617C8.31209 2.67736 8.93808 2.16432 9.66147 2.03297C9.84457 1.99972 10.0385 1.99986 10.2611 2.00002H13.7391C13.9617 1.99986 14.1556 1.99972 14.3387 2.03297C15.0621 2.16432 15.6881 2.67736 16.0264 3.41617C16.1121 3.60318 16.1733 3.81241 16.2435 4.05256L16.3583 4.44424C16.3778 4.51087 16.3833 4.52923 16.388 4.54412C16.5682 5.11033 17.1278 5.49353 17.6571 5.50879H20.2286C20.6546 5.50879 21 5.90152 21 6.38597C21 6.87043 20.6546 7.26316 20.2286 7.26316H3.77143C3.34538 7.26316 3 6.87043 3 6.38597Z"
                fill="#FF1A1A"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.5956 22H12.4044C15.1871 22 16.5785 22 17.4831 21.1141C18.3878 20.2281 18.4803 18.7749 18.6654 15.8685L18.9321 11.6806C19.0326 10.1036 19.0828 9.31511 18.6289 8.81545C18.1751 8.31579 17.4087 8.31579 15.876 8.31579H8.12404C6.59127 8.31579 5.82488 8.31579 5.37105 8.81545C4.91722 9.31511 4.96744 10.1036 5.06788 11.6806L5.33459 15.8685C5.5197 18.7749 5.61225 20.2281 6.51689 21.1141C7.42153 22 8.81289 22 11.5956 22ZM15.2463 12.3456C15.2875 11.9117 14.9868 11.5249 14.5746 11.4815C14.1625 11.4381 13.7949 11.7546 13.7537 12.1885L13.2537 17.4516C13.2125 17.8855 13.5132 18.2724 13.9254 18.3157C14.3375 18.3591 14.7051 18.0426 14.7463 17.6087L15.2463 12.3456ZM9.42537 11.4815C9.83753 11.4381 10.2051 11.7546 10.2463 12.1885L10.7463 17.4516C10.7875 17.8855 10.4868 18.2724 10.0746 18.3157C9.66247 18.3591 9.29494 18.0426 9.25372 17.6087L8.75372 12.3456C8.71251 11.9117 9.01321 11.5249 9.42537 11.4815Z"
                fill="#FF1A1A"
            />
        </svg>
    );
};

export default IconAvatarTrash;
